<script>
    import {validateEmail} from "../../Helper";

    export let config;
    export let cid;
    export let form_name;

    $ : formElems = null;
    let controlElem = "";
    let formLoader = loadForm();

    let status = {
        feedback: false,
        type: "",
        msg: ""
    }

    async function loadForm() {
        let data = await fetch(config.model_root + 'shared/forms/get_form.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
            .then((data) => {
                formElems = data;
            });
        return data;
    }

    function prepareDataForSubmitting() {
        const payload = {
            formId: cid,
            formName: form_name,
            replyTo: "",
            formElems: [],
            emptyElem: controlElem
        }
        for (let elem of formElems) {
            payload.formElems.push({
                type: elem.type,
                name: elem.title,
                value: elem.value
            })
            if (payload.replyTo.length < 1 && validateEmail(elem.value)) {
                payload.replyTo = elem.value;
            }
        }
        return JSON.stringify(payload);
    }

    function submitForm() {
        document.activeElement.blur(); // dissmiss the focus on the clicked btn
        status.type = "LOADING";

        const data = new FormData();
        data.append("payload", prepareDataForSubmitting());

        fetch(config.model_root + 'shared/forms/submit_form.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if (msg === "success") {
                    status.feedback = true;
                    status.type = "SUCCESS";
                    status.msg = "Der Inhalt wurde erfolgreich übermittelt."
                    clearAllInputs();
                } else {
                    status.msg = msg;
                    status.feedback = true;
                    if (msg.startsWith("Spam Schutz")) {
                        status.type = "SPAM_LOADING";
                        setTimeout(() => {
                            status.type = "ERROR";
                        }, 60000)
                    } else {
                        status.type = "ERROR";
                    }
                }
            });
    }

    function clearAllInputs() {
        for (let elem of formElems) {
            elem.value = "";
        }
        formElems = formElems;
    }

</script>

{#await formLoader}
    <p class="link-dark text-dark d-block my-2 px-3 py-2 mt-2 rounded downloads">
        <i class="fas fa-circle-notch fa-spin"></i> Formular wird geladen...
    </p>
{:then loaded}

    {#if formElems.length > 0}

        <form class="mb-2"
              on:submit|preventDefault={submitForm}
              on:reset|preventDefault>

            {#each formElems as item}

                <div class="form-group mt-3">

                    <label class="form-label">{item.title}</label>

                    {#if item.type === "EMAIL"}
                        <input type="email" class="form-control form-darkgreen" placeholder="{item.placeholder}" bind:value={item.value}>
                    {:else if item.type === "TEXT"}
                        <input type="text" class="form-control form-darkgreen" placeholder="{item.placeholder}" bind:value={item.value}>
                    {:else if item.type === "NUMBER"}
                        <input type="number" class="form-control form-darkgreen" placeholder="{item.placeholder}" bind:value={item.value}>
                    {:else if item.type === "TEXTFIELD"}
                        <textarea class="form-control form-darkgreen" rows="4" placeholder="{item.placeholder}" bind:value={item.value}></textarea>
                    {/if}

                    <div class="mt-1">
                        <small class="form-text">{item.description}</small>
                    </div>

                </div>

            {/each}

            <!-- empty field for spam detection -->
            <input type="text" class="form-control form-darkgreen d-none" bind:value={controlElem}>

            {#if status.feedback}
                {#if (status.type === "ERROR" || status.type === "SPAM_LOADING")}
                    <div class="alert alert-green-error mt-3">
                        <i class="fas fa-exclamation-circle me-1"></i> {status.msg}
                    </div>
                {/if}
                {#if status.type === "SUCCESS"}
                    <div class="alert alert-green-success mt-3">
                        <i class="fas fa-check-circle me-1"></i> {status.msg}
                    </div>
                {/if}
            {/if}

            <div class="form-group mt-4">
                <button type="submit" class="btn btn-dark-green px-3 py-2" disabled={ (status.type === "LOADING" || status.type === "SPAM_LOADING") }>
                    {#if status.type === "LOADING"}
                        <i class="fas fa-spinner fa-spin me-1"></i>
                    {:else}
                        <i class="far fa-paper-plane me-1"></i>
                    {/if}
                    Inhalt absenden
                </button>
            </div>

        </form>

    {/if}

{:catch error}
    <p style="color: red">{error.message}</p>
{/await}
